import {Avatar, Box, Typography} from '@mui/material';
import {ReactNode} from 'react';

/**
 * The base UI component for displaying History logs
 */
export function BaseLogAction({
  title,
  name,
  picture,
  date,
  compactDisplay = false,
  children,
  ...rest
}: {
  title: string;
  name: string;
  picture?: string;
  date?: string;
  compactDisplay?: boolean;
  children?: ReactNode;
  key?: string;
}) {
  return (
    <Box className="action" {...rest}>
      <Avatar className="action-avatar" src={picture} alt={name} />
      <Box className="action-description">
        <Typography className="title">{title}</Typography>

        <Box className="status">{children}</Box>

        {compactDisplay && (
          <Box className="date">
            <Typography>{date}</Typography>
          </Box>
        )}
      </Box>

      {!compactDisplay && (
        <Box className="date">
          <Typography>{date}</Typography>
        </Box>
      )}
    </Box>
  );
}
